import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import satellites from '../data/satellites.json';
import targets from '../data/targets.json';
import { RSCatalogProductsContainer } from './RSCatalogProductsContainer';
import { RSCatalogSatelliteNav } from './RSCatalogSatelliteNav';
import { RSCatalogTargetSelect } from './RSCatalogTargetSelect';

export const RSCatalog = () => {
  const defaultSatellite = satellites[0].name;

  const [target, setTarget] = useState<string | null>(null);
  const [satellite, setSatellite] = useState<string>(defaultSatellite);

  return (
    <>
      <div className="mb-3">
        <RSCatalogTargetSelect targets={targets} onChange={(e) => setTarget(e.target.value)} />
      </div>
      <Row>
        <Col sm={12} md={4} lg={3}>
          <RSCatalogSatelliteNav
            satellites={satellites}
            target={target}
            defaultActiveSatellite={defaultSatellite}
            onSelect={(eventKey) => (eventKey ? setSatellite(eventKey) : null)}
          />
        </Col>
        <Col>
          <RSCatalogProductsContainer satellite={satellite} target={target} />
        </Col>
      </Row>
    </>
  );
};
